// @ts-generator-hash: 2fee4ca942328406417c977cb1abe05479e07e4023687f3a005a0ae8cacbc193
// Generation date: 7/20/2026 8:07:06 AM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Helpers.DueDateBasis
export enum DueDateBasis {
  ModuleCreation = 0,
  NoaDate = 1,
}
